import type { FC } from "react"

export const AppButton: FC<{
  disabled?: boolean
  error?: string
  text?: string
  onClick?: () => void
  type?: "button" | "reset" | "submit" | undefined
  wrapperStyles?: string
  buttonStyles?: string
}> = ({
  text = "NEXT",
  wrapperStyles = "",
  buttonStyles = "bg-[#232734]",
  disabled,
  error,
  type = "button",
  onClick,
}) => {
  return (
    <div className={`flex flex-col relative w-full justify-center items-center ${wrapperStyles}`}>
      <button
        className={`${buttonStyles} flex justify-center w-full sm:w-fit px-14 items-center sm:h-12 text-sm text-white first-letter:uppercase`}
        disabled={disabled}
        onClick={onClick}
        type={type}
      >
        {text}
      </button>
      {error && (
        <p className="text-[#FF1C5E] w-full text-[9px] mt-5 absolute top-full left-1/2 transform text-center -translate-x-1/2">
          {error}
        </p>
      )}
    </div>
  )
}
